<template>
  <div class="wrapper">
    <div class="sign-in-up forgot-password" id="log-out">
      <div class="overlay"></div>
      <div class="form">
        <div class="form__content">
          <div class="lock-icon">
            <span>
              <logout-icon />
            </span>
          </div>
          <h2>{{ translatedData?.pageTitle }}</h2>

          <p class="mt-3 text-secondary">{{ translatedData?.infoText }}</p>

          <div class="button mb-4">
            <router-link :to="logoutUrl" class="btn w-100 btn-red"
              ><span
                ><strong>{{ translatedData?.logInButtonText }}</strong></span
              ></router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const loggedOutJson = {
  pageTitle: "You are logged out",
  infoText: "Need to log in to continue",
  logInButtonText: "Log In",
};
import { mapActions, mapGetters } from "vuex";
import LogoutIcon from "./LogoutIcon.vue";
import { translationMixin } from "../mixins/translationMixin";

export default {
  name: "LogOut",
  mixins: [translationMixin],
  components: { LogoutIcon },
  data() {
    return {
      signInBg: "",
      data: loggedOutJson,
    };
  },

  watch: {
    signInBg(newVal) {
      if (newVal) {
        let theBox = document.getElementById("log-out");
        theBox.style.backgroundImage = `url(${newVal})`;
        theBox.style.backgroundSize = "cover";
      }
    },
  },
  mounted() {
    this.signInBg = this.getAssets.agentPortalBackground;
    this.fetchLoaderStatus(false);
  },
  computed: {
    ...mapGetters([
      "getAssets",
      "getCompanyName",
      "getProspectId",
      "getOrgId",
      "getAppFlow",
      "getIsCoPilot",
      "getCoPilotEmail",
      "getHomePageTailUrl",
    ]),

    logoutUrl() {
      return this.getIsCoPilot
        ? "/" +
            this.getHomePageTailUrl +
            "?email=" +
            this.getCoPilotEmail +
            "&password=&type=" +
            this.getAppFlow
        : "/sign-in";
    },
  },
  methods: {
    ...mapActions(["fetchLoaderStatus"]),
  },
};
</script>
